var _ = require('lodash');;


export function processSlides(base = document) {
    base.querySelectorAll('.wp-block-smarttouch-slides').forEach(el=>{
        const config = JSON.parse(LZUTF8.decompress(el.dataset.config,{inputEncoding:'Base64'}));
        var swiper = new Swiper(el,lodash.merge(config,{
            loop: true,
			fadeEffect: { crossfade: true },
            autoHeight: (config.effect=='cube')?false:config.autoHeight
		}));
    });
}